import React, { useState } from 'react';
import { navigate } from 'gatsby';
import {
  AntenaIcon,
  TechnicalServiceIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/help';
import Panel from '@womcorp/wom-miwom-ui-kit/dist/components/Panel';
import {
  HelpContainerStyled,
  HelpContentStyled,
  HelpHeaderStyled,
} from './styles/HelpCardStyled';
import SimcardResources from './SimcardResources/SimcardResources';
import { ActionButtonStyled } from '../styles/HelpStyled';
import { useGlobalData } from '../../../contextProvider/GlobalDataContext';
import OtaRefreshPanel from './OtaRefresh/OtaRefreshPanel';
import { NetworkIssuesProvider } from '../../../contextProvider/NetworkIssuesContext';

const actionButtons = [
  {
    name: 'ServicioTecnico',
    component: () => (
      <ActionButtonStyled
        icon={TechnicalServiceIcon}
        onClick={() => navigate('/servicio-tecnico')}
        upperTitle="Servicio Técnico"
      />
    ),
  },
  { name: 'SimcardResources', component: SimcardResources },
];

const HelpCard = () => {
  const [openRefresh, setOpenRefresh] = useState(false);
  const closePanel = () => setOpenRefresh(false);
  const {
    isEnabled: { networkIssues },
  } = useGlobalData();
  const networkFunc = () => {
    if (networkIssues) {
      navigate('/ayuda/problema-senal');
    } else {
      setOpenRefresh(true);
    }
  };
  const networkButton = {
    name: 'NetworkIssues',
    component: () => (
      <ActionButtonStyled
        icon={AntenaIcon}
        onClick={networkFunc}
        upperTitle="Problemas de señal"
        $isNew={networkIssues}
      />
    ),
  };
  const actionShow = [networkButton, ...actionButtons];
  return (
    <>
      <NetworkIssuesProvider>
        <Panel
          open={openRefresh}
          title="Reinicia tu señal"
          onClose={closePanel}
        >
          <OtaRefreshPanel closePanel={closePanel} />
        </Panel>
      </NetworkIssuesProvider>
      <HelpContainerStyled>
        <HelpHeaderStyled>
          <h1>Soporte</h1>
          <h2>Resuelve los problemas de tus servicios</h2>
        </HelpHeaderStyled>
        <HelpContentStyled>
          {actionShow.map(({ name, component: ActionButton }, index) => (
            <ActionButton
              key={name}
              centerbutton={
                index + 1 === actionButtons.length && index % 3 === 0 ? 1 : 0
              }
            />
          ))}
        </HelpContentStyled>
      </HelpContainerStyled>
    </>
  );
};

export default HelpCard;
